import { defineComponent as _defineComponent } from 'vue'
import { ReferralLinks } from '@busy-human/opt-library'
import { DataInstance } from '@busy-human/gearbox'
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';

import ReferralStart from '@/components/referral/referral-start.vue'
import ReferralEmail from '@/components/referral/referral-email.vue';
import ReferralNote from '@/components/referral/referral-note.vue';
import ReferralSend from '@/components/referral/referral-send.vue'
import { httpsCallable } from 'firebase/functions';
import { functions } from '@/util/firebase';

enum ReferralStage {
    START = 1,
    EMAIL = 2,
    NOTE = 3,
    SEND = 4
}


export default /*#__PURE__*/_defineComponent({
  __name: 'referral',
  setup(__props, { expose }) {
  expose();

const tmp = ref()

const stage = ref(ReferralStage.START);
const referral = ref(ReferralLinks.Defaults());
const referralInstance = ref<DataInstance<ReferralLinks.Model> | null>(null);
const error = ref<string | null>(null);

// Firebase function isn't currently pushed, this features been put on hold anyways so I'll leave as is for now.
// const createReferralLink = httpsCallable<{data: ReferralLinks.Model}, DataInstance<ReferralLinks.Model>>(functions, 'createReferralLink');
const createLink = async () => {
    console.log("Create Link")
    // try {
    //     error.value = null;
    //     referral.value.created = new Date(Date.now()).toISOString()
    //     referral.value.createdBy = /*death*/
    //     const tmp = await createReferralLink({data: referral.value});
    //     referralInstance.value = tmp.data;
    //     console.log(referralInstance.value);
    // } catch (e) {
    //     console.error(e);
    //     error.value = "Error";
    // }
}

// const updateReferral = () => {
//     if(referralInstance.value) {
//         ReferralLinks.InviteLinks.updateDoc(referralInstance.value.$id, referralInstance.value)
//     }
// }

watch(referral, () => {
    console.log(referral.value);
}, {immediate: true})

const noScroll = ref(false)

const router = useRouter();

const goTo = (route: string) =>{
    router.push(route)
}


const __returned__ = { ReferralStage, tmp, stage, referral, referralInstance, error, createLink, noScroll, router, goTo, ReferralLinks, DataInstance, ref, watch, useRouter, ReferralStart, ReferralEmail, ReferralNote, ReferralSend, httpsCallable, functions }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})